/* eslint-disable max-len */

import { APPLIANCE_CATEGORY, CATEGORY_ACCESSORY_MAPPING, KPF_MATCH, SPEC_TITLE } from './constants';

export const getModelInfo = ({ data }) => {
  const specifications = data?.product?.specificationGroup?.find(({ specTitle }) => specTitle === SPEC_TITLE)?.specifications || [];
  const category = specifications?.find(({ specName }) => specName === APPLIANCE_CATEGORY)?.specValue || '';
  return {
    parentCategory: category,
    modelNumber: specifications?.find(({ specName }) => specName === CATEGORY_ACCESSORY_MAPPING[category])?.specValue || ''
  };
};

const isCompatibleModel = ({ keyProductFeatures, modelNumber }) => {
  return (keyProductFeatures?.keyProductFeaturesItems?.flatMap(({ features }) => {
    return features?.filter(({ name }) => name === KPF_MATCH).map(({ value }) => value);
  }))?.includes(modelNumber);
};

export const getAccessoryId = ({ data, modelNumber }) => {
  return data?.searchModel?.products?.find(({ identifiers = {}, keyProductFeatures = {} }) => {
    if (identifiers?.modelNumber === modelNumber
      || isCompatibleModel({ keyProductFeatures, modelNumber })
      || (
        modelNumber.includes(identifiers?.modelNumber)
        && modelNumber.includes('Filter')
        && !!identifiers?.modelNumber.length)) {
      return true;
    }
    return false;
  })?.itemId || '';
};
